import DateRegexp from "../regexp/DateRegexp";

const isDate = (date: string): boolean => {
  return DateRegexp.test(date);
};

export default isDate;
